module.exports = __webpack_public_path__ + "static/Ultra_Group-35d5570780529f3ba79b5c06b7ae1057.png";